import { useEffect, useRef, Children, cloneElement, ReactElement, useState, Fragment } from "react";
import { createPortal } from "react-dom";

export default function Tooltip({
  // id,
  show,
  children,
  text,
}: {
  // id: string;
  show?: boolean;
  text: string;
  children: ReactElement;
}) {
  const parentElementRef = useRef<HTMLDivElement | null>(null);
  const toolTipElmRef = useRef<HTMLDivElement | null>(null);

  const [innerShow, setInnerShow] = useState(false);

  // Internal methods
  function positionTooltip(parentElm: HTMLElement, _toolTipElm: HTMLElement) {
    const { y: top, left, width } = parentElm.getBoundingClientRect();
    const { height: tooltipHeight, width: tooltipWidth } = _toolTipElm.getBoundingClientRect();

    // Add position classes
    _toolTipElm.style.top = `${top - tooltipHeight - 10}px`;
    _toolTipElm.style.left = `${left + (width - tooltipWidth) / 2}px`;
  }

  // Portal
  const tooltip = createPortal(
    <div
      ref={toolTipElmRef}
      style={{
        zIndex: (show != undefined ? show : innerShow) ? "9999" : "-1000",
        opacity: (show != undefined ? show : innerShow) ? 1 : 0,
      }}
      className="absolute text-sm p-1 px-2 rounded-md bg-black text-white transition-all"
    >
      {text}
      <div
        className="top-full absolute"
        style={{
          width: 0,
          height: 0,
          borderLeft: "5px solid transparent",
          borderRight: "5px solid transparent",
          borderTop: "5px solid #000",
          left: "50%",
          transform: "translateX(-50%)",
        }}
      ></div>
    </div>,
    document.body
  );

  // Mount
  useEffect(() => {
    let lastDevicePixelRatio = window.devicePixelRatio;

    function onMouseOver() {
      // Adjust position
      if (parentElementRef.current && toolTipElmRef.current) positionTooltip(parentElementRef.current, toolTipElmRef.current);

      setInnerShow(true);
    }

    function onMouseOut() {
      setInnerShow(false);
    }

    function handleZoomChange() {
      console.log("Zoom changed", window.devicePixelRatio, lastDevicePixelRatio);
      if (window.devicePixelRatio !== lastDevicePixelRatio) {
        lastDevicePixelRatio = window.devicePixelRatio;

        // Reposition the tooltip
        if (parentElementRef.current && toolTipElmRef.current) {
          positionTooltip(parentElementRef.current, toolTipElmRef.current);
        }
      }
    }

    function handleWindowSizeChange() {
      if (parentElementRef.current && toolTipElmRef.current) positionTooltip(parentElementRef.current, toolTipElmRef.current);
    }

    if (parentElementRef.current && toolTipElmRef.current) {
      handleWindowSizeChange();
      window.addEventListener("resize", handleWindowSizeChange);

      // Bind to hover
      if (show === undefined) {
        parentElementRef.current.addEventListener("mouseover", onMouseOver);
        parentElementRef.current.addEventListener("mouseout", onMouseOut);
        window.removeEventListener("resize", handleWindowSizeChange);
      }
    }

    window.addEventListener("resize", handleZoomChange);

    return () => {
      window.removeEventListener("resize", handleZoomChange);
      parentElementRef.current?.removeEventListener("mouseover", onMouseOver);
      parentElementRef.current?.removeEventListener("mouseout", onMouseOut);
    };
  }, []);

  // Get element
  // const parentChild = Children.only(children);

  /* {
     cloneElement(parentChild, {
       ref: (ref: any) => (parentElementRef.current = ref),
     });
   } */

  return (
    <div ref={parentElementRef}>
      {children}
      {tooltip}
    </div>
  );
}
